import { ArrowLeft } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { InlineSkeleton } from '@/components/core';
import { Button } from '@/components/ui-kit/button';
import { UserOvertimePanel } from '../../components/user-overtime-panel/user-overtime-panel';
import { useGetOvertimeBalance } from '../../hooks/use-overtime';

/** One employee's overtime, opened from a row of the overtime manager (legacy OvertimeDetails). */
export const OvertimeDetailsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userId = '' } = useParams<{ userId: string }>();
  const { data: balance, isLoading } = useGetOvertimeBalance(userId);

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          className="shrink-0"
          aria-label={t('BACK')}
          onClick={() => navigate('/hr/overtime-manager')}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div className="flex min-w-0 flex-col">
          <h1 className="truncate text-lg font-semibold">{t('OVERTIME_AND_STATISTICS')}</h1>
          {isLoading && <InlineSkeleton className="mt-1 w-64 max-w-full" />}
          {balance && (
            <span className="break-words text-sm text-muted-foreground">
              {[balance.ResourceName, balance.ResourceEmail, balance.DepartmentName]
                .filter(Boolean)
                .join(' · ')}
            </span>
          )}
        </div>
      </div>

      <UserOvertimePanel userId={userId} />
    </div>
  );
};
